import {defineStore} from 'pinia'
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {useSuggestionStore} from "@/store/AutocompletePopup/SuggestionStore";
import {config} from "@/core/config";
import {SanitizeValue} from "@/core/utils";
import {ProductInterface} from "@/core/types";
import {SmartSearchConfig} from "@/main";
import {searchErrorLogger, searchLogger} from "@/core/Logger";
import {useUserRecentQueriesStore} from "@/store/AutocompletePopup/UserRecentQueriesStore";


export const usePopupStore = defineStore('PopupStore', {
  state: () => {
    return {
      showAutocompletePopup: false,
      showResults: false,
      results: [],
      total: 0,
      typingTimer: 0,
      loading: false,
      productsController: 0,
      bestseller: [] as Array<ProductInterface>,
      isMobileView: window.innerWidth <= 768,
      
    }
  },
  getters: {
    hasAnyResults(state) {
      return state.results.length > 0
    },
    getTotalProducts(state): number {
      return state.total
    },
    hasNoResults(state) {
      return state.results.length === 0
    },
    canShowPromotedSection(state){
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return state.total >= SmartSearchConfig.value.autocomplete.results.count
    },
    getBestseller(state) {
      return state.bestseller
    },
    getAutocompleteResultsWithoutFirst(state) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return state?.results?.slice(1, SmartSearchConfig.value.autocomplete.results.count + 1)
    },
    getAutocompleteResults(state) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return state?.results?.slice(0, SmartSearchConfig.value.autocomplete.results.count)
    }
  },
  actions: {
    setBodyActiveAutocompleteClass(set: boolean) {
      if (set) {
        document.body.classList.add('q-autocomplete-active');
      } else {
        document.body.classList.remove('q-autocomplete-active');
      }
    },
    showAutocomplete() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // if (!SmartSearchConfig.value.onfocus.showOnfocus) {
      //   return
      // }
      this.showAutocompletePopup = true;
      this.setBodyActiveAutocompleteClass(true)
    },
    hideAutocomplete() {
      this.showAutocompletePopup = false;
      this.setBodyActiveAutocompleteClass(false)
    },
    clearBestseller() {
      this.bestseller = []
    },
    handleKeyUp() {
      const queryStore = useSearchQueryStore();
      const suggestionStore = useSuggestionStore();
      
      if (queryStore.searchQuery.length <= 2) {
        suggestionStore.showSuggestions = false;
        this.showResults = false;
        return;
      }
      
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }
      
      
      this.typingTimer = setTimeout(async () => {
        try {
          this.loading = true;
          await Promise.all([suggestionStore.fetchNewSuggestions(), this.fetchAutocompleteResults()]);
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      }, 400);
    },
    async fetchAutocompleteResults() {
      const queryStore = useSearchQueryStore();
      if (queryStore.searchQuery.length < 3) {
        return;
      }
      const userRecentQueriesStore = useUserRecentQueriesStore()
      userRecentQueriesStore.addQuery(queryStore.searchQuery)
      
      if (this.productsController) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.productsController.abort();
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.productsController = new AbortController();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const {signal} = this.productsController
      
      const data = new FormData();
      const sanitizedQuery = SanitizeValue(queryStore.searchQuery)
      data.append('q', sanitizedQuery);
      
      try {
        this.loading = true;
        const response = await fetch(`https://${config.apiHost}/restapi/${config.customerSymbol}/search/${config.searchId}/products`, {
          method: 'POST',
          headers: {
            'Api-key': config.apiKey,
          },
          credentials: 'include',
          body: data,
          signal,
        });
        
        if (response.ok) {
          const data = await response.json();
          this.clearBestseller()
          const {products, meta} = data;
          
          const {total} = meta
          
          this.total = total
          this.results = products;
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // if (this.total >= SmartSearchConfig.value.autocomplete.results.count) {
          //   console.log('wpadam w ifa')
            this.bestseller = products[0]
          // }
          
          this.showResults = true;
          this.loading = false;
        }
      } catch (error) {
        this.showResults = false;
        this.loading = false;
        searchErrorLogger.log('Error retrieving search results:', error);
      }
    },
    updateIsMobileView() {
      this.isMobileView = window.innerWidth <= 768;
    },
    
    
    handleClickOutside() {
      searchLogger.log('handleClickOutside event')
      const searchInput = document.getElementById('autocomplete-search__input');
      const autocompletePopup = document.getElementById('smartsearch-autocomplete__popup-container');
      if (!searchInput || !autocompletePopup) {
        searchLogger.log('handleClickOutside: !searchInput || !autocompletePopup')
        return;
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!searchInput.contains(event.target) && !autocompletePopup.contains(event.target)) {
        this.hideAutocomplete();
        return;
      }
      searchLogger.log('hideAutocomplete niespelniony warunek')
      
    }
  },
})